// src/internal/components/help-center-panel/help-center-content/search-input.tsx
import { useRef } from "react";
import { Divider, TextField } from "@mui/material";
import { CrossIcon, SearchIcon } from "@clara/icons";
import { useT } from "@clara/locale";
import { Flex, IconButton, theme } from "@clara/ui";
import { jsx, jsxs } from "react/jsx-runtime";
var timeoutToSearch = null;
var SearchInput = ({ onChange }) => {
  var _a;
  const { t } = useT("common");
  const inputRef = useRef(null);
  const changeSearch = () => {
    if (timeoutToSearch)
      clearTimeout(timeoutToSearch);
    timeoutToSearch = setTimeout(() => {
      var _a2;
      onChange(((_a2 = inputRef.current) == null ? void 0 : _a2.value) || "");
    }, 400);
  };
  return /* @__PURE__ */ jsx(
    TextField,
    {
      inputRef,
      onChange: changeSearch,
      label: t("helpCenter.panel.searchInputLabel"),
      InputProps: {
        endAdornment: /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
          !!((_a = inputRef.current) == null ? void 0 : _a.value) && /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
            /* @__PURE__ */ jsx(
              IconButton,
              {
                icon: /* @__PURE__ */ jsx(CrossIcon, {}),
                variant: "alternative",
                onClick: () => {
                  onChange("");
                  if (inputRef.current)
                    inputRef.current.value = "";
                },
                "aria-label": ""
              }
            ),
            /* @__PURE__ */ jsx(Divider, { flexItem: true, orientation: "vertical" })
          ] }),
          /* @__PURE__ */ jsx(SearchIcon, { sx: { color: theme.palette.v3.content.low_emphasis } })
        ] })
      }
    }
  );
};

export {
  SearchInput
};
